import { Col, Pagination, Row, Typography } from 'antd';
import { PaginationProps } from 'antd/lib';
import { useTranslation } from 'react-i18next';
import CollapsableFilter from '../../../../shared/components/collapsable-filter/collapsable-filter';
import FormActions from '../../../../shared/components/form-actions/form-actions';
import PageTitle from '../../../../shared/components/page-title/page-title';
import { useBreakpoint } from '../../../../shared/hooks/use-breakpoint';
import useFormWithSearchParams from '../../../../shared/hooks/use-form-with-search-params';
import { customerFilterFormId } from '../../constants/constants';
import { CustomerParams } from '../../models/customer-params';
import CustomersFilterForm from './customers-filter-form/customers-filter-form';

interface Props {
  pagination?: PaginationProps;
}

const CustomersHeader = ({ pagination }: Props): JSX.Element => {
  const screens = useBreakpoint();
  const { t } = useTranslation('common');
  const form = useFormWithSearchParams<Pick<Required<CustomerParams>, 'name' | 'surname' | 'email' | 'phone'>>();

  return (
    <>
      {screens.sm ? (
        <>
          <PageTitle>{t('label.customers')}</PageTitle>
          <CustomersFilterForm form={form} />
          <Row justify="space-between">
            <Col className="paginationPadding" flex="auto">
              <FormActions form={form} formId={customerFilterFormId} />
            </Col>
            <Col flex="auto" className="pagination-col paginationPadding">
              <Pagination {...pagination} />
            </Col>
          </Row>
        </>
      ) : (
        <>
          <CollapsableFilter keyProp="1" header={<Typography.Text strong>{t('label.filters')}</Typography.Text>}>
            <CustomersFilterForm form={form} />
            <FormActions form={form} formId={customerFilterFormId} />
          </CollapsableFilter>
          <div className="paginationPadding">
            <Pagination {...pagination} />
          </div>
        </>
      )}
    </>
  );
};
export default CustomersHeader;
